var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a-modal',{attrs:{"title":"找回密码","visible":_vm.visible,"confirmLoading":_vm.confirmLoading,"cancelText":"取消","okText":"确定"},on:{"ok":_vm.handleOk,"cancel":_vm.handleCancel}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }